import React, { useState, useEffect } from "react";
import {
  Tab,
  Tabs,
  Form,
  Button,
  Modal,
} from "react-bootstrap";
import { MapPin, User, X } from "lucide-react";
import Profile from "../../assets/images/priest-default.png";
import corruptedImg from "../../assets/images/corrupted-img.png";
import moment from "moment";
import { toast } from "react-toastify";
import OtherParishModal from "../../components/OtherParishModal";
import PriestApi from "../../api/priestApi";
import { useNavigate } from "react-router-dom";
import { formatParishOptionLabel } from "../../utils/parishLabels";
import "../../assets/css/coupleFormModal.css";

const UpdatePriestPopUp = ({
  showRegModal,
  onHide,
  data,
  isEditAdmin,
  parishList,
  setParishList,
  ediUserIdClicked,
  CloseCompose,
  roasterCount,
  userData,
  roastersOfPriestList,
  coupleOldValues,
  setShowREgModal,
  setEdiUserIdClicked,
  getAllPriests,
  setData,
  oldValues,
  setOldValues,
  isTempUpload,
  isTempUpload2,
  setIsTempUpload,
  retreatDetail = null,
  redirect = true,
  onSuccess = null,
}) => {
  const [validated, setValidated] = useState(false);
  const [oldData, setOldData] = useState([]);
  const [otherParishModalOpen, setOtherParishModalOpen] = useState(false);
  let priestApi = new PriestApi();
  const [emailErrors, setEmailErrors] = useState({
    email: "",
  });
  const navigate = useNavigate();

  const upload = () => {
    document.getElementById("PriestProfileUpload").click();
    setIsTempUpload(true);
  };

  const remove = () => {
    let d = { ...data };
    d.imageUrl = "";
    setData(d);
    setIsTempUpload(false);
  };

  const handleChanges = (e) => {
    let { name, value } = e.target;
    let d = { ...data };
    let o = { ...oldData };

    if (name === "title") {
      o.title = oldValues.title;
    } else if (name === "firstName") {
      o.firstName = oldValues.firstName;
    } else if (name === "lastName") {
      o.lastName = oldValues.lastName;
    } else if (name === "email") {
      o.email = oldValues.email;
    } else if (name === "parishId") {
      if (value === "OTHER") {
        setOtherParishModalOpen(true);
      }
      if (value === "") {
        value = retreatDetail?.parishId || "";
      }
      d.parishId = value;
      o.parishId = oldValues.parishId;

      // Auto-populate address fields from parish data
      const selectedParish = parishList.find((p) => p.id === parseInt(value));
      if (selectedParish) {
        d.address = selectedParish.address || "";
        d.city = selectedParish.city || "";
        d.state = selectedParish.state || "";
        d.zip = selectedParish.zip || "";
      } else {
        d.address = "";
        d.city = "";
        d.state = "";
        d.zip = "";
      }
    }
    setOldData(o);

    // ONLY FOR UPLOAD PRIEST IMAGE
    if (name === "imageUrl") {
      const file = e.target.files[0];
      if (file) {
        const fileSizeInMB = file.size / (1024 * 1024); // Convert size from bytes to MB
        if (fileSizeInMB > 3) {
          alert("File size should be less than 3 MB");
          return;
        } else {
          d[name] = file;
          const successMessage =
            name === "imageUrl"
              ? "The profile image has been successfully added."
              : "";
          toast.success(successMessage);
        }
      }
    } else {
      d[name] = value;
    }
    setData(d);

    if (name === "email") {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (value && !emailRegex.test(value)) {
        setEmailErrors((prev) => ({ ...prev, [name]: "Invalid email format" }));
      } else {
        setEmailErrors((prev) => ({ ...prev, [name]: "" }));
      }
    }
  };

  const handleSubmit = (e) => {
    const form = e.currentTarget;
    e.preventDefault();
    e.stopPropagation();

    if (emailErrors.email) {
      toast.error("Please enter a valid email address.");
      return;
    }

    if (form.checkValidity()) {
      if (
        ediUserIdClicked &&
        ediUserIdClicked !== "" &&
        ediUserIdClicked !== null
      ) {
        let data1 = new FormData();
        if (data.imageUrl !== "") {
          data1.append("file", data.imageUrl);
        }
        let stateRef = { ...data };
        if (stateRef.parishId === "" || stateRef.parishId === null) {
          stateRef.parishId = retreatDetail.parishId || "";
        }
        data1.append("fromData", JSON.stringify(stateRef));
        priestApi
          .editPriest(data1)
          .then(async (res) => {
            if (res.success) {
              toast.success(res.msg);
              if (redirect) {
                navigate("/priest-list");
              } else {
                getAllPriests && getAllPriests();
                if (CloseCompose) {
                  CloseCompose();
                } else if (onHide) {
                  onHide();
                }
              }
              if (onSuccess) {
                onSuccess(res.data);
              }
                            
              
              let oldparish = parishList.find((i) => i.id === oldData.parishId);
              let newparish = parishList.find(
                (i) => i.id === res.data.parishId,
              );
              
              
              
              
              
              
              
              clearfield();
              setData({
                id: "",
                title: "",
                firstName: "",
                lastName: "",
                email: "",
                city: "",
                state: "",
                zip: "",
                imageUrl: "",
                parishId: null,
                address: "",
              });
              setOldData([]);
              setShowREgModal(false);
              setEdiUserIdClicked("");
              getAllPriests();
            } else {
              toast.error(res.msg);
            }
          })
          .catch((error) => {
            toast.error(error);
          });
      } else {
        let data1 = new FormData();
        data1.append("file", data.imageUrl);
        let stateRef = { ...data };
        if (stateRef?.parishId === "" || stateRef?.parishId === null) {
          stateRef.parishId = retreatDetail?.parishId || "";
        }
        delete stateRef.imageUrl;
        data1.append("fromData", JSON.stringify(stateRef));
        priestApi
          .createPriest(data1)
          .then(async (res) => {
            if (res.success) {
              if (redirect) {
                navigate("/priest-list");
              } else {
                getAllPriests && getAllPriests();
                if (CloseCompose) {
                  CloseCompose();
                } else if (onHide) {
                  onHide();
                }
              }
              if (onSuccess) {
                onSuccess(res.data);
              }
              toast.success(res.msg);
              clearfield();
              setEdiUserIdClicked("");
              setShowREgModal(false);
              getAllPriests();
              remove();
              setData({
                id: "",
                firstName: "",
                lastName: "",
                email: "",
                city: "",
                state: "",
                zip: "",
                imageUrl: "",
                address: "",
              });
            } else {
              toast.error(res.msg);
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    }
    setValidated(true);
  };

  const clearfield = () => {
    setData({
      id: "",
      parishId: null,
      title: "",
      firstName: "",
      lastName: "",
      email: "",
      city: "",
      state: "",
      zip: "",
      imageUrl: "",
      address: "",
    });
    setValidated(false);
  };

  const hasPriestPhoto = data?.imageUrl !== "" && data?.imageUrl != undefined;
  const priestName = [data?.title, data?.firstName, data?.lastName]
    .filter(Boolean)
    .join(" ");
  const editingPriest = Boolean(ediUserIdClicked && ediUserIdClicked !== "");

  const renderPriestRetreats = () => {
    const retreatRows = Array.isArray(roastersOfPriestList)
      ? roastersOfPriestList
      : [];
    const retreatLabel = (row) => {
      const language = row?.language
        ? ` (${String(row.language).charAt(0).toUpperCase()}${String(row.language).slice(1)})`
        : "";
      const location = row?.location
        ? ` ${String(row.location).charAt(0).toUpperCase()}${String(row.location).slice(1)}`
        : "";
      return `${row?.parish || "Retreat"}${language}${location}`.trim();
    };
    const retreatDates = (row) => {
      if (!row?.dateFrom) return "";
      if (row.dateFrom === row.dateTo) {
        return moment(row.dateFrom).format("MMM DD, YYYY");
      }
      return `${moment(row.dateFrom).format("MMM DD")} – ${moment(row.dateTo).format("MMM DD, YYYY")}`;
    };

    return (
      <div className="rr-couple-retreats">
        <div className="rr-couple-retreats-count">
          <div>
            <span>Retreats Attended</span>
            <p>Retreats this spiritual director has joined, with their role on each one.</p>
          </div>
          <strong>{roasterCount || retreatRows.length}</strong>
        </div>
        {retreatRows.length === 0 ? (
          <div className="rr-couple-retreats-empty">
            This spiritual director is not on a retreat roster yet.
          </div>
        ) : (
          <ul className="rr-couple-retreat-list">
            {retreatRows.map((row, index) => {
              const title = retreatLabel(row);
              const dates = retreatDates(row);
              const linked = !(userData && userData.userRole === "SUBADMIN");
              const roleLabel = row?.role ? `${row.role} (Priest)` : "Priest";
              return (
                <li
                  className="rr-couple-retreat-card"
                  key={`${row.id || "retreat"}-${index}`}
                >
                  <div className="rr-couple-retreat-main">
                    {linked ? (
                      <a
                        href={`/retreatRoster?retreatId=${row.id}`}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {title}
                      </a>
                    ) : (
                      <strong>{title}</strong>
                    )}
                    {dates ? <span>{dates}</span> : null}
                  </div>
                  <dl className="rr-couple-retreat-meta">
                    <div>
                      <dt>Type</dt>
                      <dd>
                        {row?.attendeeType === "Team" ? (
                          <span className="rr-couple-type rr-couple-type--team">
                            {row.attendeeType}
                          </span>
                        ) : row?.attendeeType ? (
                          <span className="rr-couple-type">{row.attendeeType}</span>
                        ) : (
                          <span className="rr-couple-empty-cell">—</span>
                        )}
                      </dd>
                    </div>
                    <div>
                      <dt>Role</dt>
                      <dd>{roleLabel}</dd>
                    </div>
                    <div>
                      <dt>Talk</dt>
                      <dd className={row?.talk ? "" : "is-empty"}>
                        {row?.talk || "—"}
                      </dd>
                    </div>
                  </dl>
                </li>
              );
            })}
          </ul>
        )}
      </div>
    );
  };

  return (
    <>
      <Modal
        show={showRegModal}
        onHide={onHide}
        centered
        enforceFocus={false}
        className="rr-couple-modal rr-priest-modal"
        dialogClassName="rr-couple-dialog"
        contentClassName="rr-couple-content"
        aria-labelledby="rr-priest-modal-title"
      >
        <div className="rr-couple-shell">
          <header className="rr-couple-header">
            <div className="rr-couple-mark" aria-hidden="true">
              <User size={20} />
            </div>
            <div className="rr-couple-header-copy">
              <p className="rr-couple-kicker">Spiritual director</p>
              <h2 id="rr-priest-modal-title">
                {editingPriest
                  ? "Edit Spiritual Director"
                  : "Add a Spiritual Director"}
              </h2>
              <p>
                {priestName ||
                  "Name, parish, contact details, and the retreats they have joined."}
              </p>
            </div>
            <button
              type="button"
              className="rr-couple-close"
              onClick={onHide}
              aria-label="Close"
            >
              <X size={18} />
            </button>
          </header>
          <div className="rr-couple-edit">
            <Tabs
              defaultActiveKey="Spiritual Director (Priest) Details"
              id="rr-priest-edit-tabs"
              className="rr-couple-tabs"
            >
              <Tab
                eventKey="Spiritual Director (Priest) Details"
                title="Details"
              >
                <Form
                  onSubmit={handleSubmit}
                  noValidate
                  validated={validated}
                  className="forms-sample rr-couple-form"
                >
                  <Modal.Body className="rr-couple-body">
                    <div className="rr-couple-fields">
                      <section className="rr-couple-section rr-priest-profile">
                        <div className="rr-couple-photo-wrap">
                          <div
                            className={`rr-couple-photo${
                              hasPriestPhoto ? "" : " is-empty"
                            }`}
                          >
                            {hasPriestPhoto ? (
                              <img
                                src={
                                  isTempUpload
                                    ? URL.createObjectURL(data.imageUrl)
                                    : data.imageUrl || data.priestImage
                                }
                                alt="Spiritual director"
                                onError={(e) => {
                                  e.target.onerror = null;
                                  e.target.src = corruptedImg;
                                }}
                              />
                            ) : (
                              <img src={Profile} alt="" />
                            )}
                          </div>
                          {hasPriestPhoto ? (
                            userData && userData.userRole === "SUBADMIN" ? null : (
                              <button
                                type="button"
                                className="rr-couple-photo-btn is-danger"
                                onClick={() => remove()}
                              >
                                Remove photo
                              </button>
                            )
                          ) : (
                            <>
                              <input
                                name="imageUrl"
                                type="file"
                                accept="image/*"
                                id="PriestProfileUpload"
                                onChange={(e) => handleChanges(e)}
                              />
                              <button
                                type="button"
                                className="rr-couple-photo-btn"
                                onClick={() => upload()}
                              >
                                Upload photo
                              </button>
                            </>
                          )}
                        </div>
                        <div className="rr-priest-id-block">
                          <Form.Group className="rr-couple-id">
                            <Form.Label htmlFor="primaryKey">Priest ID</Form.Label>
                            <Form.Control
                              required
                              size="sm"
                              type="text"
                              name="primaryKey"
                              id="primaryKey"
                              placeholder="Priest Id"
                              value={data.primaryKey ?? ""}
                              className="form-control"
                              onChange={(e) => handleChanges(e)}
                              readOnly
                            />
                            <span className="rr-couple-hint">
                              Assigned automatically and used on every retreat.
                            </span>
                            <Form.Control.Feedback type="invalid">
                              Priest Id is required!
                            </Form.Control.Feedback>
                          </Form.Group>
                        </div>
                      </section>

                      <section className="rr-couple-section">
                        <div className="rr-couple-section-head">
                          <span className="rr-couple-section-icon" aria-hidden="true">
                            <User size={16} />
                          </span>
                          <div>
                            <h3>Priest</h3>
                            <p>Parish first, then name and email.</p>
                          </div>
                        </div>
                        <div className="rr-priest-fields">
                          <Form.Group className="form-group rr-priest-span">
                              <Form.Label
                                className={data.parishId ? null : "highlightField"}
                              >
                                Parish <span className="text-danger">*</span>
                              </Form.Label>
                              <Form.Select
                                required
                                size="sm"
                                name="parishId"
                                value={data.parishId || ""}
                                onChange={(e) => handleChanges(e)}
                              >
                                <option value="">NONE / NINGUNA</option>
                                <option value="OTHER">OTHER / OTRA</option>
                                <optgroup label="Select Parish">
                                  {parishList
                                    .filter(
                                      (p) =>
                                        p.parishCategoryName?.toUpperCase() !==
                                        "OTHER",
                                    )
                                    .map((p) => (
                                      <option key={p.id} value={p.id}>
                                        {formatParishOptionLabel(p)}
                                      </option>
                                    ))}
                                </optgroup>
                                <optgroup label="OTHER">
                                  {parishList
                                    .filter(
                                      (p) =>
                                        p.parishCategoryName?.toUpperCase() ===
                                        "OTHER",
                                    )
                                    .map((p) => (
                                      <option key={p.id} value={p.id}>
                                        {formatParishOptionLabel(p, {
                                          omitCategory: true,
                                        })}
                                      </option>
                                    ))}
                                </optgroup>
                              </Form.Select>
                              <Form.Control.Feedback type="invalid">
                                Parish is required!
                              </Form.Control.Feedback>
                            </Form.Group>
                          <Form.Group className="form-group">
                              <Form.Label
                                className={data.title ? null : "highlightField"}
                              >
                                Title <span className="text-danger">*</span>
                              </Form.Label>
                              <Form.Select
                                required
                                size="sm"
                                name="title"
                                id="title"
                                value={data.title}
                                onChange={(e) => handleChanges(e)}
                                readOnly={isEditAdmin}
                              >
                                <option value="">Title</option>
                                <option value="Fr.">Fr.</option>
                                <option value="Rev.">Rev.</option>
                                <option value="Msgr.">Msgr.</option>
                                <option value="Dcn.">Dcn.</option>
                              </Form.Select>
                              <Form.Control.Feedback type="invalid">
                                Title is required!
                              </Form.Control.Feedback>
                            </Form.Group>
                          <Form.Group className="form-group">
                              <Form.Label
                                className={
                                  data.firstName ? null : "highlightField"
                                }
                              >
                                First Name <span className="text-danger">*</span>
                              </Form.Label>
                              <Form.Control
                                required
                                size="sm"
                                type="text"
                                name="firstName"
                                id="firstName"
                                placeholder="First Name"
                                value={data.firstName}
                                className="form-control"
                                onChange={(e) => handleChanges(e)}
                                readOnly={isEditAdmin}
                              />
                              <Form.Control.Feedback type="invalid">
                                First Name is required!
                              </Form.Control.Feedback>
                            </Form.Group>
                          <Form.Group className="form-group">
                              <Form.Label
                                className={data.lastName ? null : "highlightField"}
                              >
                                Last Name <span className="text-danger">*</span>
                              </Form.Label>
                              <Form.Control
                                required
                                size="sm"
                                type="text"
                                name="lastName"
                                id="lastName"
                                placeholder="Last Name"
                                value={data.lastName}
                                className="form-control"
                                onChange={(e) => handleChanges(e)}
                                readOnly={isEditAdmin}
                              />
                              <Form.Control.Feedback type="invalid">
                                Last Name is required!
                              </Form.Control.Feedback>
                            </Form.Group>
                          <Form.Group className="form-group rr-priest-span">
                              <Form.Label>Email</Form.Label>
                              <Form.Control
                                size="sm"
                                type="email"
                                name="email"
                                id="email"
                                placeholder="Email"
                                value={data.email}
                                onChange={(e) => handleChanges(e)}
                                readOnly={isEditAdmin}
                              />
                              {emailErrors.email && (
                                <span
                                  className="text-danger"
                                  style={{ fontSize: "12px" }}
                                >
                                  {emailErrors.email}
                                </span>
                              )}
                              <Form.Control.Feedback type="invalid">
                                Email is required!
                              </Form.Control.Feedback>
                            </Form.Group>
                        </div>
                      </section>

                      <section className="rr-couple-section">
                        <div className="rr-couple-section-head">
                          <span className="rr-couple-section-icon" aria-hidden="true">
                            <MapPin size={16} />
                          </span>
                          <div>
                            <h3>Parish Address</h3>
                            <p>Filled from the selected parish.</p>
                          </div>
                        </div>
                        <div className="rr-priest-address">
                          <Form.Group className="form-group rr-priest-span">
                            <Form.Label>Address</Form.Label>
                            <Form.Control
                              size="sm"
                              type="text"
                              name="address"
                              id="address"
                              placeholder="Address"
                              value={data.address}
                              onChange={(e) => handleChanges(e)}
                              readOnly
                            />
                          </Form.Group>
                          <Form.Group className="form-group">
                            <Form.Label>City</Form.Label>
                            <Form.Control
                              size="sm"
                              type="text"
                              name="city"
                              id="city"
                              placeholder="City"
                              value={data.city}
                              onChange={(e) => handleChanges(e)}
                              readOnly
                            />
                          </Form.Group>
                          <Form.Group className="form-group">
                            <Form.Label>State</Form.Label>
                            <Form.Control
                              size="sm"
                              type="text"
                              name="state"
                              id="state"
                              placeholder="State"
                              value={data.state}
                              onChange={(e) => handleChanges(e)}
                              readOnly
                            />
                          </Form.Group>
                          <Form.Group className="form-group">
                            <Form.Label>Zip</Form.Label>
                            <Form.Control
                              size="sm"
                              type="text"
                              name="zip"
                              id="zip"
                              placeholder="Zip"
                              value={data.zip}
                              onChange={(e) => handleChanges(e)}
                              readOnly
                            />
                          </Form.Group>
                        </div>
                      </section>
                    </div>
                  </Modal.Body>
                  <Modal.Footer className="rr-couple-footer">
                    <p className="rr-couple-footer-note">
                      Fields marked with * are required.
                    </p>
                    <div className="rr-couple-footer-actions">
                      <Button
                        type="button"
                        variant="light"
                        className="rr-couple-btn rr-couple-btn--ghost"
                        onClick={() => {
                          if (CloseCompose) {
                            CloseCompose();
                          } else if (onHide) {
                            onHide();
                          }
                        }}
                      >
                        Cancel
                      </Button>
                      {userData && userData.userRole === "SUBADMIN" ? null : (
                        <Button
                          variant="primary"
                          type="submit"
                          className="rr-couple-btn rr-couple-btn--primary"
                        >
                          {editingPriest ? "Save Changes" : "Submit"}
                        </Button>
                      )}
                    </div>
                  </Modal.Footer>
                </Form>
              </Tab>
              <Tab eventKey="Retreats" title="Retreats">
                {renderPriestRetreats()}
              </Tab>
            </Tabs>
          </div>
        </div>
      </Modal>
      <OtherParishModal
        show={otherParishModalOpen}
        handleClose={() => setOtherParishModalOpen(false)}
        registerationData={data}
        setRegisterationData={setData}
        setParishList={setParishList}
        parishList={parishList}
      />
    </>
  );
};

export default UpdatePriestPopUp;
